export default theme => ({
  title: {
    marginBottom: theme.spacing.unit * 4,
  },
})
